<template>
  <span class="use-hand-cursor my-link" @click="onClickSupport()">
    <div>
      <img
        class="whatsapp-support"
        src="/static/img/whatsapp-ico.png"
        width="26"
        height="26"
      />
      <span class="whatsapp-support">{{
        $t('message.application_support')
      }}</span>
    </div>
    <div>
      <span class="whatsapp-support">{{
        $t('message.application_support_phone')
      }}</span>
    </div>
  </span>
</template>
<script>
export default {
  methods: {
    onClickSupport() {
      window.open('https://api.whatsapp.com/send?phone=554630259584', '_blank')
    }
  }
}
</script>
<style>
.whatsapp-support {
  vertical-align: middle;
  color: inherit;
  font-size: 16px;
}
.whatsapp-support:hover {
  color: inherit;
}

.my-link {
  color: #fff;
}

.my-link:hover {
  color: #babec5;
}
</style>



// WEBPACK FOOTER //
// src/components/WhatsAppSupport/WhatsAppSupportLink.vue